import { render } from "./BackNextButtons.vue?vue&type=template&id=10dc639c&ts=true"
import script from "./BackNextButtons.vue?vue&type=script&lang=ts"
export * from "./BackNextButtons.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__